import App from "@/App.vue";

export default [
  {
    path: "/dashboard",
    name: "home",
    component: App,
    redirect: { name: "dashboard" },
    children: [
      {
        path: "",
        name: "dashboard",
        component: () =>
          import("../views/HomeDashboard.vue"),
        meta: {
          breadcrumb: [
            {
              text: "Dashboard",
              disabled: false,
              link: false,
              to: { name: "home" }
            }
          ],
          displayName: "Dashboard - Lockton",
          requiresAuth: true,
          permissionRoute: "dashboard_inicial"
        }
      }
    ]
  }
];